import React, {useState} from 'react'
//import axios from 'axios'
import logo2 from './logo.png';
import { useNavigate } from 'react-router-dom';


function Register(){
    

    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [firstname, setFirstname] = useState('')
    const [midname, setMidname] = useState('')
    const [lastname, setLastname] = useState('')

    const [email, setEmail] = useState('')
    const [cfpassword, setCfpassword] = useState('')

    const [affiliation, setAffiliation] = useState('')

    const [address, setAddress] = useState([])

  
const [selectedTitle, setSelectedTitle] = useState('Mr.'); // State to store the selected value

  const titles = [
    { value: 'Dr', label: 'Dr.' },
    { value: 'Mr', label: 'Mr.' },
    { value: 'Ms', label: 'Ms.' },
    { value: 'Mrs', label: 'Mrs.' },
    { value: 'Prof', label: 'Prof.' }
  ];

   

  const handleChange = (event) => {
     
    setSelectedTitle(event.target.value); // Update state on change
    
  };

  const navigate = useNavigate();   
    
const confirmPassword = (e) => {
    e.preventDefault();
    if(password !== cfpassword){
        alert("Passwords do not match!")
    }
    else{
        alert("Passwords match!")
    }
    navigate('/login'); 
}   


    //const submitEntry =() =>{}

   //  useEffect(()=>
  //  {
   //     axios.get('https://jtvetapi.onrender.com/entries')
    //    .then(res=>setEntries(res.data))
        
        
   // }, [])

   // const submitEntry = () =>{ 
    //    axios.post('https://jtvetapi.onrender.com/entries', {title, author, date, doi})
   //     .then(()=>window.location.reload())
   // }


return(
    
    <div className="App"
    
    
    >
         <img src={logo2}  alt="logo" />
        <h1>Journal of Technical and Vocational Education and Training</h1>
        <h2>Welcome To Corresponding Author Registration!</h2>
        <p><i>Enter Your details below as corresponding Author</i></p>
        <form className=''>

     <p className='title2'>Select Title:</p>
      <select id="title-select" value={selectedTitle} onChange={handleChange} className='title-select'>
        {titles.map((title) => (
          <option key={title.value} value={title.value}>
            {title.label}
          </option>
        ))}

       
      </select>
       <br/>
        <br/>
        <input className='input' value ={firstname} onChange={e=>setFirstname(e.target.value)} placeholder="First Name"/>
        <br/>
        <input className='input' value ={midname} onChange={e=>setMidname(e.target.value)} placeholder="Middle Name"/>
        <br/>
        <input className='input' value ={lastname} onChange={e=>setLastname(e.target.value)} placeholder="Last Name"/>
        <br/>
         <br/>
        <input className='input'  type='email' value ={email} onChange={e=>setEmail(e.target.value)} placeholder='Email'/>
        <br/>
        <input className='input'  value ={affiliation} onChange={e=>setAffiliation(e.target.value)} placeholder='Affiliation'/>
        <br/>
        <input className='input'  value ={username} onChange={e=>setUsername(e.target.value)} placeholder='Username'/>
        <br/>
        <input className='input' type="password" value ={password} onChange={e=>setPassword(e.target.value)} placeholder="Password"/>
        <br/>
        <input className='input' type="password" value ={cfpassword} onChange={e=>setCfpassword(e.target.value)} placeholder="Confirm Password"/>
        <br/>
        <textarea value ={address} onChange={e=>setAddress(e.target.value)} placeholder="Enter Address"/>
        <br/>
       
        <button className='button' type="submit" onClick={confirmPassword}>Register</button>
       
        
        </form>
       <footer><small>Copyright &copy; 2026 Designed by | ISITEC</small></footer>
    </div>

)
}

export default Register